import { handleActions, createAction } from 'redux-actions';
import { cloneDeep, get } from 'lodash';

export const FETCH_INVOICES = createAction('FETCH/INVOICES');
export const FETCH_INVOICES_SUCCESS = createAction('FETCH/INVOICES/SUCCESS');
export const FETCH_INVOICES_FAIL = createAction('FETCH/INVOICES/FAIL');
export const UNSET_BOLD = createAction('UNSET/BOLD');

const initialState = {
  invoicesErrors: null,
  total_pages: null,
  total_count: null,
  invoices: null,
};

const invoicesReducer = handleActions(
  {
    [FETCH_INVOICES_SUCCESS]: (state, { payload, }) => {
      return { ...state, ...payload, };
    },
    [FETCH_INVOICES_FAIL]: (state, { payload: { error, }, }) => {
      return { state, invoicesErrors: error, };
    },
    [UNSET_BOLD]: (state, { payload: { id, }, }) => {
      const indexOfInvoice = get(state, 'invoices').findIndex((element) => get(element, 'id') === id);
      if (indexOfInvoice < 0) {
 return state;
}
      const newState = cloneDeep(state);
      newState.invoices[indexOfInvoice].seen_by_dealer = true;
      return newState;
    },
  },
  initialState
);

export default invoicesReducer;
